
































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType: string = "productfeatures/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "标题", dataIndex: "title" },
    { title: "排序号", dataIndex: "sortid" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "更新时间", dataIndex: "updated_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
